import { useMemo } from "react"
import { useLocation } from "react-router-dom"

import { PLAYLIST } from "@/data"

import { ROUTE_NAMES } from "../data/route-names"

type PlaylistItem = {
  link?: string
  artistLink?: string
  title?: string
  type?: string
}

export function useRouteTitle() {
  const location = useLocation()

  const title = useMemo(() => {
    const path = location.pathname

    const limit = (str: string, max: number) =>
      str.length > max ? str.slice(0, max) + "…" : str

    const playlistMatch = path.match(/^\/playlist\/(.+)/)
    const artistMatch = path.match(/^\/artist\/(.+)/)

    if (playlistMatch) {
      const slug = playlistMatch[1]

      const playlist = (PLAYLIST as PlaylistItem[]).find(
        (item) => item.link === slug
      )

      return limit(playlist?.title || "Playlist", 32)
    }

    if (artistMatch) {
      const slug = artistMatch[1]

      const artist = (PLAYLIST as PlaylistItem[]).find(
        (item) =>
          item.type === "djs" &&
          item.artistLink === slug
      )

      return limit(artist?.title || "Artista", 30)
    }

    return limit(ROUTE_NAMES[path] || " ", 30)
  }, [location.pathname])

  return title
}
